import { createFileRoute } from "@tanstack/react-router";
import { SignupsScreen } from "./-signups/SignupsScreen";

export const Route = createFileRoute("/admin/signups")({
  staticData: { title: "Signups" },
  component: SignupsScreen,
});
